(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name quote.directive:oqsQuestionControl
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="quote">
   <file name="index.html">
   <oqs-question-control></oqs-question-control>
   </file>
   </example>
   *
   */
  angular
    .module('quote')
    .directive('oqsQuestionControl', oqsQuestionControl);

  function oqsQuestionControl() {
    return {
      restrict: 'EA',
      scope: {
        question: '=oqsQuestionModel',
        validationActive: '=oqsValidationActive',
        sectionInstance: '=oqsSectionInstance'
      },
      templateUrl: 'quote/directives/oqs-question-control-directive.tpl.html',
      replace: false,
      controllerAs: 'oqsQuestionControl',
      bindToController: true,
      controller: QuestionControlController,
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }

  QuestionControlController.$inject = ['$scope', 'moment', '_', 'DataService', '$log'];

  function QuestionControlController($scope, moment, _, dataService, $log) {
    var vm = this;
    vm.name = 'oqsQuestionControl';
    vm.day = null;
    vm.month = null;
    vm.year = null;
    vm.dayOptions = dayOptions;
    vm.monthOptions = monthOptions;
    vm.yearOptions = yearOptions;
    vm.updateDateAnswer = updateDateAnswer;
    vm.updatePostalCodeAnswer = updatePostalCodeAnswer;
    vm.question.hidden = false;
    vm.configureSectionList = configureSectionList;
    vm.watchedQuestions = {};
    vm.isInputFieldWithinComboSliderRange = isInputFieldWithinComboSliderRange;
    vm.onComboSliderInputFieldChange = onComboSliderInputFieldChange;
    vm.getComboSliderPopupMessage = getComboSliderPopupMessage;
    vm.isFormElementRequired = isFormElementRequired;
    vm.sectionList = {};

    activate();

    function activate() {
      updateDateControl();
      if (vm.question.definition.inputControl === 'COMBOSLIDER') {
        configureComboSlider();
      }
      if (vm.question.definition.optionList.length > 0) {
        // Regular dropdown scenario
        vm.question.optionList = vm.question.definition.optionList;
      } else if (angular.isDefined(vm.question.definition.attributes.optionListUrl)) {
        configureDynamicOptionList();
      }
      if (angular.isDefined(vm.question.definition.attributes.sectionList)) {
        configureSectionList();
      }
      if (vm.question.definition.attributes.hideExpression) {
        configureHideExpression();
      }
      if (vm.question.definition.attributes.defaultExpression) {
        configureDefaultExpression();
      }
    }

    function configureComboSlider() {
      vm.question.definition.attributes.required = 'true';
      vm.question.answer = Number(vm.question.answer);
      vm.comboSliderInputFieldValue = vm.question.answer;
      $scope.$watch('oqsQuestionControl.question.answer', function () {
        if (vm.question.answer !== null && angular.isDefined(vm.question.answer)) {
          vm.comboSliderInputFieldValue = vm.question.answer;
        }
      }, true);
    }

    function updateDateControl() {
      var selectedMoment;
      if (angular.isDefined(vm.question.answer) && vm.question.definition.inputControl === 'DATE') {
        selectedMoment = moment(vm.question.answer, 'YYYY-MM-DD', true);
        if (selectedMoment.isValid()) {
          vm.day = selectedMoment.date();
          vm.month = selectedMoment.format('MMM');
          vm.year = selectedMoment.year();
        }
      } else {
        vm.day = null;
        vm.month = null;
        vm.year = null;
      }
    }

    function configureSectionList() {
      var foundSection,
          sectionIndex,
          sectionListFilterExpression = vm.question.definition.attributes.sectionListFilterExpression;
      vm.sectionList = dataService.data.viewModel.selectedQuoteType.sectionList;

      sectionIndex = _.findIndex(vm.sectionList, function (section) {
        return section.definition.name === vm.question.definition.attributes.sectionList;
      });

      foundSection = vm.sectionList[sectionIndex];

      vm.question.optionList = _.forEach(foundSection.instanceList, function (instance, index) {
        instance.name = instance.getHeading();
        instance.value = index;
      });

      $scope.$watch('oqsQuestionControl.sectionList', function (newValue, oldValue) {
        var optionList,
            isAvailableOperator,
            includeInList,
            foundIndex,
            primaryDriverQuestion;

        optionList = _.forEach(foundSection.instanceList, function (instance, index) {
          instance.name = instance.getHeading();
          instance.value = index;
        });

        // The selected primary driver should be excluded from the occasional driver select box
        isAvailableOperator = function () {
          return true;
        };
        if (vm.question.definition.attributes.flag === 'occasional') {
          primaryDriverQuestion = findQuestionByFlagInSection('primary', vm.sectionInstance);
          if (primaryDriverQuestion && primaryDriverQuestion.answer !== null && angular.isDefined(primaryDriverQuestion.answer)) {
            isAvailableOperator = function (sectionInstance) {
              return sectionInstance.value !== primaryDriverQuestion.answer;
            };
          }
        }

        // If there is a sectionListFilterExpression, the sectionInstance will be included in the list only if the filter expression evaluates to true for that sectionInstance
        includeInList = function () {
          return true;
        };
        if (sectionListFilterExpression) {
          includeInList = function (sectionInstance) {
            var retVal = true;
            try {
              retVal = evalExpression(replaceQuestionAnswerReferences(sectionListFilterExpression, sectionInstance), 'includeExpression for ' + vm.question.definition.name);
            } catch (question) {
              $log.debug('Could not substitute answers for includeExpression ' + sectionListFilterExpression + ' on question ' + vm.question.definition.name);
            }
            return retVal;
          };
        }

        /*
         * If a section instance (a tab in the UI) has been removed from the instanceList, the answer might
         * point to the wrong section, so we have find the correct section instance and set the answer to it
         * */
        if (newValue[sectionIndex].instanceList.length < oldValue[sectionIndex].instanceList.length) {
          if (angular.isDefined(oldValue[sectionIndex].instanceList[vm.question.answer])) {
            foundIndex = _.findIndex(newValue[sectionIndex].instanceList, function (sectionInstance) {
              return sectionInstance.id === oldValue[sectionIndex].instanceList[vm.question.answer].id;
            });
            if (foundIndex > -1) {
              if (foundIndex !== vm.question.answer) {
                $log.debug('Moving the answer on question ' + vm.question.definition.name + ' from ' + vm.question.answer + ' to ' + foundIndex);
                vm.question.answer = foundIndex;
              }
            } else {
              vm.question.answer = null;
            }
          }
        }

        if (vm.question.definition.attributes.flag === 'occasional' || sectionListFilterExpression) {
          optionList = _.filter(optionList, function (sectionInstance) {
            return includeInList(sectionInstance) && isAvailableOperator(sectionInstance);
          });
        }
        vm.question.optionList = optionList;
      }
      , true);
    }

    function configureHideExpression() {
      var hideExpression = vm.question.definition.attributes.hideExpression,
          questionList = addWatchesForExpression(hideExpression, 'hideExpression', function () {
            var expressionWithSubstitutions;
            $log.debug('Watch for hideExpression fired!');
            try {
              expressionWithSubstitutions = replaceQuestionAnswerReferences(vm.question.definition.attributes.hideExpression, vm.sectionInstance);
              vm.question.hidden = evalExpression(expressionWithSubstitutions, vm.question.definition.name);
              if (!vm.question.hidden && vm.question.answer === null) {
                vm.question.answer = vm.question.definition.defaultValue;
              }
            } catch (question) {
              $log.debug('Cannot evaluate hideExpression for ' + vm.question.definition.name + ', question ' + question.definition.name + ' is not answered.');
              vm.question.hidden = true;
            }
            if (vm.question.hidden) {
              vm.question.answer = null;
            }
          });
      if (questionList.length < 1) {
        // No watches, just evaluate the expression once
        vm.question.hidden = evalExpression(hideExpression, vm.question.definition.name);
      }
    }

    function configureDynamicOptionList() {
      var questionList = addWatchesForExpression(vm.question.definition.attributes.optionListUrl, 'optionList', _.debounce(function () {
        $log.debug('Watch for watchedOptionListQuestions fired!');
        try {
          vm.question.optionListUrl = replaceQuestionAnswerReferences(vm.question.definition.attributes.optionListUrl, vm.sectionInstance);
          dataService.getOptionList(vm.question);
        } catch (question) {
          $log.debug('Cannot create optionList for ' + vm.question.definition.name + ', question ' + question.definition.name + ' is not answered.');
          vm.question.optionList = [];
        }
      }, 500));
      if (questionList.length < 1) {
        // No watches just get the option list
        vm.question.optionListUrl = vm.question.definition.attributes.optionListUrl;
        dataService.getOptionList(vm.question);
      }
    }

    function configureDefaultExpression() {
      var defaultExpression = vm.question.definition.attributes.defaultExpression,
          questionList = addWatchesForExpression(defaultExpression, 'defaultExpression', function (newValue, oldValue) {
            var expressionWithSubstitutions;
            $log.debug('Watch for defaultExpression fired!');
            // We only want to evaluate the default expression if there has been a change to any of the watched questions
            // or if the quote type has not been initiated (in which case we want to evaluate the expression and set the initial default value)
            if (newValue !== oldValue || !dataService.data.initiatedQuoteTypes[dataService.data.viewModel.selectedQuoteType.definition.id]) {
              try {
                expressionWithSubstitutions = replaceQuestionAnswerReferences(vm.question.definition.attributes.defaultExpression, vm.sectionInstance);
                vm.question.answer = evalExpression(expressionWithSubstitutions, vm.question.definition.name);
                updateDateControl();
                $log.debug('The answer of question ' + vm.question.definition.name + ' was set to ' + vm.question.answer);
              } catch (question) {
                $log.debug('Cannot evaluate defaultExpression for ' + vm.question.definition.name + ', question ' + question.definition.name + ' is not answered.');
              }
            }
            if (vm.question.hidden) {
              vm.question.answer = null;
            }
          });
      if (questionList.length < 1) {
        // No watches, just evaluate the expression once
        vm.question.answer = evalExpression(defaultExpression, vm.question.definition.name);
      }
    }

    function addWatchesForExpression(expression, watchName, handleFunction) {
      var questionList = getWatchedQuestionList(expression);
      $log.debug('Found an expression for ' + watchName + ' : ' + expression);
      if (questionList.length > 0) {
        // We've got a watch scenario
        vm.watchedQuestions[watchName] = questionList;
        $scope.$watch('oqsQuestionControl.watchedQuestions.' + watchName, handleFunction, true);
      }
      return questionList;
    }

    function evalExpression(expression, questionName) {
      var retVal;
      $log.debug('Executing expression for ' + questionName + ': ' + expression);
      try {
        /* jshint ignore:start */
        retVal = eval(expression); // eslint-disable-line
        /* jshint ignore:end */
      } catch (err) {
        $log.error('Error when evaluating expression for question ' + questionName);
        retVal = true;
      }
      return retVal;
    }

    function updatePostalCodeAnswer() {
      vm.question.answer = dataService.formatPostalCode(vm.question.answer);
    }

    function updateDateAnswer() {
      var selectedMoment = moment(vm.year + '-' + vm.month + '-' + vm.day, 'YYYY-MMM-D', true);
      if (selectedMoment.isValid()) {
        vm.question.answer = selectedMoment.format('YYYY-MM-DD');
      } else {
        vm.question.answer = null;
      }
    }

    function onComboSliderInputFieldChange() {
      if (vm.isInputFieldWithinComboSliderRange()) {
        vm.question.answer = vm.comboSliderInputFieldValue;
      } else {
        vm.question.answer = null;
      }
    }

    function isInputFieldWithinComboSliderRange() {
      return isWithinRange(vm.comboSliderInputFieldValue, vm.question.definition.attributes.min, vm.question.definition.attributes.max);
    }

    function isWithinRange(value, max, min) {
      return angular.isDefined(value) &&
        value !== null &&
        Number(value) > Number(max) - 1 &&
        Number(value) < Number(min) + 1;
    }

    function getComboSliderPopupMessage() {
      if (vm.question.definition.helpInfo !== null) {
        return vm.question.definition.helpInfo;
      }
      return 'Enter a number between ' + vm.question.definition.attributes.min + ' and ' + vm.question.definition.attributes.max;
    }

    function monthOptions() {
      return moment.monthsShort();
    }

    function dayOptions() {
      return range(daysInMonth());
    }

    function yearOptions(count) {
      var yearArray = [];
      _.times(count, function (n) {
        yearArray.push(moment().year() - n);
      });
      return yearArray;
    }

    function daysInMonth() {
      if (vm.month !== null && angular.isDefined(vm.month)) {
        if (vm.year !== null && angular.isDefined(vm.year)) {
          return moment().year(vm.year).month(vm.month).daysInMonth();
        }
        return moment().month(vm.month).daysInMonth();
      }
      return 31;
    }

    function range(count) {
      var rangeArray = [];
      _.times(count, function (n) {
        rangeArray.push(n + 1);
      });
      return rangeArray;
    }

    function findQuestionByNameInSection(questionName, section) {
      return _.find(section.questionList, function (question) {
        return question.definition.name === questionName;
      });
    }

    function findQuestionByFlagInSection(flagName, section) {
      return _.find(section.questionList, function (question) {
        return question.definition.attributes.flag === flagName;
      });
    }

    function getWatchedQuestionList(referenceString) {
      var pattern = /\$\{[^\}]+\}/g,
          questionList = [];
      _.forEach(referenceString.match(pattern), function (match) {
        var questionToWatch = findQuestionByNameInSection(match.slice(2, -1), vm.sectionInstance);
        questionList.push(questionToWatch);
      });
      $log.debug('Question ' + vm.question.definition.name + ' is watching ' + questionList.length + ' other question(s)');
      return questionList;
    }

    function replaceQuestionAnswerReferences(referenceString, sectionInstance) {
      var pattern = /\$\{[^\}]+\}/g;
      return referenceString.replace(pattern, function replacer(match) {
        var question = findQuestionByNameInSection(match.slice(2, -1), sectionInstance);
        if (question.answer === null) {
          // One of the questions has no answer, throw an exception
          throw question;
        }
        return findQuestionByNameInSection(match.slice(2, -1), sectionInstance).answer;
      });
    }

    function isFormElementRequired() {
      return vm.question.definition.attributes.required && !vm.question.hidden;
    }
  }
}());
